import type { FC } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormSelect } from '@/components/ui/form/FormSelect.tsx'
import { FormField } from '@/components/ui/form/form-field'
import { FormSwitch } from '@/components/ui/form/form-switch'

import { FUNNEL_ENTRY_TYPE_OPTIONS } from '../../consts'
import { FunnelEntryType } from '../../types'

interface Props {}

export const FunnelTrackingForm: FC<Props> = () => {
  const { watch, control } = useFormContext()

  const goesThroughInstagramEnabled =
    watch('entryPointType') === FunnelEntryType.TikTok

  return (
    <div className="flex flex-col gap-y-6">
      <FormSelect
        label="Entry Point Type"
        name="entryPointType"
        options={FUNNEL_ENTRY_TYPE_OPTIONS}
      />
      <FormField
        label="Entry Point Data"
        name="entryPointData"
      />
      <FormField
        label="Goal URL"
        name="goalUrl"
      />
      {goesThroughInstagramEnabled && (
        <FormSwitch
          label="Goes through Instagram"
          name="goesThroughInstagram"
          control={control}
        />
      )}
    </div>
  )
}
